import ColorService from "./Color.service";
const BootstrapColors = {
    Success: "#088000",
    Danger: "#C0392B",
    Warning: "#ffc107",
    Info: "#19A1A9",
    Primary: "#575195",
    Secondary: "#6B6B6B",
    Dark: "#4A4A4A",
    Light: "#FAFAFA",
};
export default BootstrapColors;
/**
 * Bootstrap colors as RGB
 */
export const BootstrapColorsRGB = Object.keys(BootstrapColors).reduce((sum, key) => (Object.assign(Object.assign({}, sum), { [key]: ColorService.hexToRGB(BootstrapColors[key]) })), {});
/**
 * Bootstrap colors as functions which accept an alpha value between 0 and 1 and return an RGB object
 */
export const BootstrapColorsRGBA = Object.keys(BootstrapColors).reduce((sum, key) => (Object.assign(Object.assign({}, sum), { [key]: (a) => (Object.assign(Object.assign({}, ColorService.hexToRGB(BootstrapColors[key])), { a })) })), {});
/**
 * Bootstrap colors as functions which accept an alpha value between 0 and 1 and return a stringified RGB object
 */
export const BootstrapColorsRGBAString = Object.keys(BootstrapColors).reduce((sum, key) => (Object.assign(Object.assign({}, sum), { [key]: (a) => ColorService.RGBToString(Object.assign(Object.assign({}, ColorService.hexToRGB(BootstrapColors[key])), { a })) })), {});
